import { Action } from "redux";

export const SET_SERVER_ERROR = "SET_SERVER_ERROR";
export const RESET_SERVER_ERROR = "RESET_SERVER_ERROR";

export interface SetServerErrorAction {
  type: typeof SET_SERVER_ERROR;
  payload: {
    message: string;
    header?: string;
    timestamp: number;
    redirectUrl?: string;
  };
}

export interface ResetServerErrorAction {
  type: typeof RESET_SERVER_ERROR;
  error?: undefined;
}

export type ErrorActions = SetServerErrorAction | ResetServerErrorAction;

export interface ErrorState {
  message?: string;
  header?: string;
  timestamp?: number;
  redirectUrl?: string;
}

const initialState: ErrorState = {};

export function errorReducer(state = initialState, action: Action): ErrorState {
  switch (action.type) {
    case SET_SERVER_ERROR:
      return {
        message: (action as SetServerErrorAction).payload.message,
        header: (action as SetServerErrorAction).payload.header,
        timestamp: (action as SetServerErrorAction).payload.timestamp,
        redirectUrl: (action as SetServerErrorAction).payload.redirectUrl,
      };
    case RESET_SERVER_ERROR:
      return {};
    default:
      return state;
  }
}

export function setServerError(message: string, header?: string, redirectUrl?: string): SetServerErrorAction {
  return {
    type: SET_SERVER_ERROR,
    payload: { message, header, timestamp: Date.now(), redirectUrl },
  };
}

export function resetServerError(): ResetServerErrorAction {
  return {
    type: RESET_SERVER_ERROR,
    error: undefined, // TypeScript requires payload to be defined, but we don't use it
  };
}
